import { paymentTxnReport } from './states';

export const services = {
  paymentTxnReport,
};
